import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { tr } from "../lib/i18n";
import SocialAccountsPanel from "../components/SocialAccountsPanel";
import ImageAiSection from "../components/ImageAiSection";

export default function SocialAccountsPage() {
  return (
    <div data-testid="social-accounts-page">
      <div className="kicker">{tr("x.social_media")}</div>
      <h1 className="mt-2 mb-6" style={{ fontSize: 30, fontWeight: 600 }}>{tr("x.social_accounts")}</h1>
      <SocialAccountsPanel />
      <ImageAiSection />
    </div>
  );
}

/** Meta sends the admin back here after signing in on Facebook. */
export function SocialCallbackPage() {
  const [q] = useSearchParams();
  const nav = useNavigate();
  const once = useRef(false);
  const [choose, setChoose] = useState(null);
  const [error, setError] = useState("");

  const done = () => { toast.success(tr("x.social_connected_toast")); nav("/social/accounts", { replace: true }); };
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    if (q.get("error") || !q.get("code")) { setError(tr("x.social_login_cancelled")); return; }
    api.post("/social/meta/callback", { code: q.get("code"), state: q.get("state") })
      .then(({ data }) => (data.connected ? done() : setChoose(data)))
      .catch((e) => setError(formatApiError(e)));
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const pick = async (id) => {
    try { await api.post("/social/meta/select", { state: choose.state, page_id: id }); done(); } catch (e) { setError(formatApiError(e)); }
  };

  return (
    <div className="panel p-5 max-w-lg" data-testid="social-callback-page">
      {error ? <>
        <p className="text-sm text-red-500" data-testid="social-callback-error">{error}</p>
        <button className="btn-secondary mt-4" onClick={() => nav("/social/accounts")} data-testid="social-callback-back">{tr("x.back")}</button>
      </> : choose ? <>
        <p className="text-sm mb-3">{tr("x.pick_showroom_page")}</p>
        <div className="space-y-2">
          {choose.choose.map((p) => (
            <button key={p.id} className="btn-secondary w-full justify-between" onClick={() => pick(p.id)} data-testid={`social-pick-page-${p.id}`}>
              <span>{p.name}</span><bdi className="text-xs">{p.ig_username ? `@${p.ig_username}` : tr("x.no_instagram")}</bdi>
            </button>
          ))}
        </div>
      </> : <p className="text-sm" data-testid="social-callback-wait">{tr("x.finishing_connection")}</p>}
    </div>
  );
}
